export default __webpack_public_path__ + "static/media/image.falcon-eye-corporation.55cd19c1.png";